import type {
  ChatbotTenantAnalyticsDTO,
  PlatformChatTenantAnalyticsDTO,
} from '@liks/lac-svc-api/esm/models/index';

export type LacKnowledgeBaseStatsCard = {
  knowledgeBaseId: string;
  name: string;
  description: string;
  chatbotCount: number;
  chatbotMessageCount: number;
  platformSessionCount: number;
  platformMessageCount: number;
};

export function mergeKnowledgeBaseStatsCards(
  chatbotRows: ChatbotTenantAnalyticsDTO[],
  platformRows: PlatformChatTenantAnalyticsDTO[],
): LacKnowledgeBaseStatsCard[] {
  const byId = new Map<string, LacKnowledgeBaseStatsCard>();

  for (const row of chatbotRows) {
    const knowledgeBaseId = row.knowledgeBaseId?.trim() ?? '';
    if (knowledgeBaseId === '') {
      continue;
    }

    byId.set(knowledgeBaseId, {
      knowledgeBaseId,
      name: row.knowledgeBaseName?.trim() || knowledgeBaseId,
      description: row.knowledgeBaseDescription?.trim() ?? '',
      chatbotCount: row.chatbotCount ?? 0,
      chatbotMessageCount: row.messageCount ?? 0,
      platformSessionCount: 0,
      platformMessageCount: 0,
    });
  }

  for (const row of platformRows) {
    const knowledgeBaseId = row.knowledgeBaseId?.trim() ?? '';
    if (knowledgeBaseId === '') {
      continue;
    }

    const existing = byId.get(knowledgeBaseId);
    if (existing) {
      existing.platformSessionCount = row.sessionCount ?? 0;
      existing.platformMessageCount = row.messageCount ?? 0;
      if (!existing.name && row.knowledgeBaseName?.trim()) {
        existing.name = row.knowledgeBaseName.trim();
      }
      if (!existing.description && row.knowledgeBaseDescription?.trim()) {
        existing.description = row.knowledgeBaseDescription.trim();
      }
      continue;
    }

    byId.set(knowledgeBaseId, {
      knowledgeBaseId,
      name: row.knowledgeBaseName?.trim() || knowledgeBaseId,
      description: row.knowledgeBaseDescription?.trim() ?? '',
      chatbotCount: 0,
      chatbotMessageCount: 0,
      platformSessionCount: row.sessionCount ?? 0,
      platformMessageCount: row.messageCount ?? 0,
    });
  }

  return [...byId.values()];
}
